import { useCallback, useSyncExternalStore } from 'react';

const noop = () => undefined;
const noOpSubscribe = () => noop;
const getTrue = () => true;

export const useClientSnapshot = <T>(getClientSnapshot: () => T, serverSnapshot: T): T => {
  const getServerSnapshot = useCallback(() => serverSnapshot, [serverSnapshot]);

  return useSyncExternalStore(noOpSubscribe, getClientSnapshot, getServerSnapshot);
};

export const useIsClient = (): boolean => useClientSnapshot(getTrue, false);
